import "./src/fonts";
import "@justinribeiro/lite-youtube";

const isIntercomEnabled = () =>
  process.env.NODE_ENV === `production` &&
  typeof Intercom === `function` &&
  window.IntercomAppId;

/** @type {import("gatsby").GatsbyBrowser["onInitialClientRender"]} */
export function onInitialClientRender() {
  if (isIntercomEnabled()) {
    window.Intercom("boot", {
      app_id: window.IntercomAppId,
    });
  }
}

/** @type {import("gatsby").GatsbyBrowser["onRouteUpdate"]} */
export function onRouteUpdate() {
  if (isIntercomEnabled()) {
    window.Intercom("update");
  }
}

/** @type {import("gatsby").GatsbyBrowser["shouldUpdateScroll"]} */
export function shouldUpdateScroll(params) {
  const { prevRouterProps, routerProps } = params;

  const oldPathname = prevRouterProps
    ? prevRouterProps.location.pathname
    : null;
  const pathname = routerProps ? routerProps.location.pathname : null;
  const keepScrollPositionRoutes = [
    `/expert-network-directory/`,
    `/expert-network-directory`,
    `/newsroom`,
    `/newsroom/`,
    `/blog`,
    `/blog/`,
  ];
  if (
    keepScrollPositionRoutes.indexOf(pathname) !== -1 &&
    oldPathname === pathname
  ) {
    return false;
  }

  return true;
}
